const $$splitComponentImporter = () => import('/app/src/routes/booking/payment-result.$outcome.$session.$token.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
// Monri return URL of a therapist-created hold paid through the finalize link.
// The hold token lets a declined payment link straight back to the pay page.
// The query string belongs to Monri and is ignored.
export const Route = createFileRoute("/booking/payment-result/$outcome/$session/$token")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});